import { useMemo } from 'react'

import ABSENCE_REASON_MESSAGES from 'constants/absenceReasons'

export default function useActivationBlock({ status, ally, business }) {
  return useMemo(() => {
    const absenceCode = (business?.absenceReason || '').trim()
    const otherForPair =
      business && ally && [1, 2].includes(business.businessId)
        ? ally.storeBusinesses?.find(
            (sb) =>
              (sb.businessId === 1 || sb.businessId === 2) && sb.businessId !== business.businessId
          )
        : null
    const otherAbsenceCode = (otherForPair?.absenceReason || '').trim()
    let isActivationBlocked = false
    let tooltipMessage = ''
    if ([1, 2].includes(business?.businessId)) {
      const bothPresent = Boolean(otherForPair)
      const bothEmpty = absenceCode === '' && otherAbsenceCode === ''
      isActivationBlocked = !bothPresent || !bothEmpty
      tooltipMessage =
        ABSENCE_REASON_MESSAGES[absenceCode] ||
        ABSENCE_REASON_MESSAGES[otherAbsenceCode] ||
        (!bothPresent ? 'No se puede activar: falta información de módulos requeridos.' : '')
    } else {
      isActivationBlocked = absenceCode !== ''
      tooltipMessage = ABSENCE_REASON_MESSAGES[absenceCode] || ''
    }
    return { isActivationBlocked, tooltipMessage }
  }, [status, ally, business])
}
